/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SmsFlowView } from '../models/SmsFlowView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SmsTemplatesService {
    /**
     * @returns SmsFlowView
     * @throws ApiError
     */
    public static smsTemplatesList({
        templateType,
        status,
    }: {
        templateType: string,
        status?: string,
    }): CancelablePromise<Array<SmsFlowView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/sms-templates/',
            query: {
                'status': status,
                'template_type': templateType,
            },
        });
    }
}
